import { millisecondsToDeciseconds } from 'src/utils/number/milliseconds-to-deciseconds';

/**
 * Maximum bar width
 */
const MAX_WIDTH = 45;

/**
 * Get the bar width in pixels.
 */
export function getBarWidth(time: number, baseTime: number): number {
  const averageMoveTime = millisecondsToDeciseconds(baseTime) / 40;
  const moveTimeRatio = time / averageMoveTime;

  return ((MAX_WIDTH * 2) / Math.PI) * Math.atan(moveTimeRatio / 3);
}
